/* eslint-disable @typescript-eslint/no-explicit-any */
import { Skeleton, VStack, HStack, Grid, Stack, css, Box, Heading, Icon, useToast, Button } from '@chakra-ui/react';
import { MainTemplate } from '../../templates/MainTemplate';
import { useTheme } from '../../contexts/ThemeProvider';
import { Label } from '../../components/atoms/Label';
import { useProfile } from '@/contexts/ProfileProvider';
import { IContrat, IFaturas } from '@/service/club/types';
import useIsMobile from '../../hooks/use-is-mobile';
import React, { useEffect } from 'react';
import { GrDocumentTime } from 'react-icons/gr';
import { format, set } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useGetContract, useGetFaturas } from '@/service/club/hooks';
import { FaFrown } from 'react-icons/fa';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  List,
  ListItem,
} from '@chakra-ui/react';
import { axiosInstance } from '@/service/axios';
import { useNavigate } from 'react-router-dom';
import { FaFileContract, FaWhatsapp } from 'react-icons/fa6';
import { MdUpgrade } from 'react-icons/md';
import { FaShieldAlt } from 'react-icons/fa';
import { APP_EVENTS, spawnAppEvent } from '@/service/utils';
import { masks } from '@/utils/masks';

const BoxLink = ({
  name,
  onPress,
  color,
  icon,
}: {
  onPress: () => void;
  color: string;
  name: string;
  to: string;
  icon: any;
}) => {
  return (
    <Box
      as="button"
      onClick={() => onPress()}
      borderRadius="lg"
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      alignItems={'flex-start'}
      backgroundColor="white"
      overflow="hidden"
      height="110px"
      padding="20px"
      boxShadow={'2px 2px 6px 0px #0000002E'}
      width="100%"
    >
      <Icon color={color} as={icon} boxSize={6} marginBottom="10px" />
      <Heading color="#292927" fontWeight={'500'} textAlign={'left'} fontSize="16px">
        {name}
      </Heading>
    </Box>
  );
};

const BoxFatura = ({
  title,
  paga,
  subtitle,
  onPress,
  active,
  color,
}: {
  onPress: () => void;
  color: string;
  title: string;
  paga?: boolean;
  subtitle?: string;
  active?: boolean;
}) => {
  return (
    <Box
      as="button"
      onClick={() => onPress()}
      borderRadius="lg"
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      alignItems={'flex-start'}
      backgroundColor={active ? color : 'white'}
      overflow="hidden"
      border={`1px solid ${color}`}
      padding="10px"
      width="fit-content"
    >
      <Heading
        textTransform={'capitalize'}
        color={active ? 'white' : color}
        fontWeight={'500'}
        textAlign={'left'}
        fontSize="16px"
      >
        {title}
      </Heading>
      <Heading color={active ? 'white' : color} fontWeight={'500'} textAlign={'left'} fontSize="16px">
        {subtitle}
      </Heading>
      {/* {paga ? (
        <Label color={active ? 'white' : color} fontSize="sm" fontWeight={'500'} textAlign={'left'}>
          Pago
        </Label>
      ) : (
        <Label color={active ? 'white' : color} fontSize="sm" fontWeight={'500'} textAlign={'left'}>
          Pendente
        </Label>
      )} */}
    </Box>
  );
};

const orderByVencimento = (array: any) => {
  const faturas: any = array;

  return faturas
    .sort((a: any, b: any) => {
      return (
        new Date(b.vencimento?.split('/').reverse().join('-')).getTime() -
        new Date(a.vencimento?.split('/').reverse().join('-')).getTime()
      );
    })
    .reverse();
};

const isValidDate = (dateString: string) => {
  const date = new Date(dateString.split('/').reverse().join('-'));
  return !isNaN(date.getTime());
};

export function FaturaPage() {
  const { colors, isApp, customerCentralModule, integrationId, cellphone } = useTheme();
  const profile: any = useProfile();
  const isMobile = useIsMobile();
  const { data: dataContratos, isLoading } = useGetContract();
  const { data: dataFaturas, isLoading: IsLoadingFaturas } = useGetFaturas();

  const [contratos, setContratos] = React.useState([]);
  const [faturas, setFaturas] = React.useState<any>([]);

  const nav = useNavigate();

  const [isError, setIsError] = React.useState(false);

  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const toast = useToast();
  const [lastFatura, setLastFatura] = React.useState<IFaturas>();
  const [lastContrato, setLastContrato] = React.useState<IContrat>();
  const [segundaVia, setSegundaVia] = React.useState<any>({
    link_segunda_via: null,
    base64_segunda_via: null,
    observacao: null,
  });

  const [isLoadingSegundaVia, setIsLoadingSegundaVia] = React.useState<any>(false);

  const handleChangeFatura = (fatura: any) => {
    setLastFatura(fatura);

    if (integrationId && ['mk', 'ixc', 'top'].includes(integrationId)) {
      getBoleto(fatura.codigo_fatura);
    }
  };

  const getBoleto = async (codigo_fatura: string) => {
    setIsLoadingSegundaVia(true);
    const { data: response } = await axiosInstance.get(`/faturas/segunda-via/`, {
      params: {
        codigo_fatura,
      },
    });

    console.log(response);
    setSegundaVia({
      link_segunda_via: response.link_segunda_via,
      base64_segunda_via: response.base64_segunda_via,
      observacao: response.observacao,
    });
    setIsLoadingSegundaVia(false);
  };

  const handleDesbloqueio = async () => {
    try {
      const { data: response } = await axiosInstance.get(`/desbloqueio-confianca`, {
        params: {
          cpf: profile?.data?.cpf,
        },
      });

      console.log(response);
      toast({
        title: 'Confiança desbloqueada com sucesso, aguarde o contato do nosso atendimento',
        status: 'success',
        duration: 9000,
        isClosable: true,
      });
    } catch (error: any) {
      toast({
        title: error?.response?.data?.error || 'Erro ao desbloquear confiança',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    }
  };

  const downloadSecondVia = async (base64_segunda_via: string) => {
    if (base64_segunda_via) {
      const byteCharacters = atob(base64_segunda_via);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);

      if (isApp) {
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = 'segundaVia.pdf';
        link.click();
      } else {
        window.open(blobUrl, '_blank');
      }
      URL.revokeObjectURL(blobUrl);
    } else {
      toast({
        title: 'Erro ao baixar a segunda via',
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    }
  };

  const handleOpenLink = (openPdf: string) => {
    if (isApp) {
      spawnAppEvent(APP_EVENTS.OPEN_LINK, openPdf);
    } else {
      window.open(openPdf, '_blank');
    }
  };

  const handleOpenWhatsAppPlan = () => {
    const phoneNumber = cellphone ? masks.unmask(cellphone) : '5531984011893';
    const message = `Olá, gostaria de ajuda com meu contrato ${lastContrato?.codigo_contrato}`;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    if (isApp) {
      spawnAppEvent(APP_EVENTS.OPEN_LINK, url);
    } else {
      window.open(url, '_blank');
    }
  };
  const handleOpenWhatsApp = () => {
    const phoneNumber = cellphone ? masks.unmask(cellphone) : '5531984011893';
    const message = 'Olá, gostaria de ajuda com minha fatura';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    if (isApp) {
      spawnAppEvent(APP_EVENTS.OPEN_LINK, url);
    } else {
      window.open(url, '_blank');
    }
  };

  useEffect(() => {
    const dataFaturasAux: any = dataFaturas?.results?.Faturas || [];

    if (!dataFaturas?.results) {
      setIsError(true);
    } else {
      setIsError(false);
    }
    if (dataFaturasAux?.length > 0) {
      const faturas = orderByVencimento(dataFaturasAux);

      setFaturas(faturas);

      handleChangeFatura(faturas[faturas.length - 1]);
    }
  }, [dataFaturas]);

  useEffect(() => {
    const dataContratosAux: any = dataContratos?.results?.Contratos || [];

    if (dataContratosAux?.length > 0) {
      const contratos = orderByVencimento(dataContratosAux);

      setContratos(contratos);
      setLastContrato(contratos[contratos.length - 1]);
    }
  }, [dataContratos]);

  const showBoxes = React.useMemo(() => {
    const boxes = [];

    if (lastFatura?.base64_segunda_via) {
      boxes.push(
        <BoxLink
          onPress={() => downloadSecondVia(lastFatura?.base64_segunda_via)}
          color={colors.primaryColor}
          name="Segunda Via"
          to="meus-dados"
          icon={GrDocumentTime}
        />
      );
    }

    if (lastFatura?.link_segunda_via) {
      boxes.push(
        <BoxLink
          onPress={() => lastFatura.link_segunda_via && handleOpenLink(lastFatura.link_segunda_via)}
          color={colors.primaryColor}
          name="Segunda Via"
          to="meus-dados"
          icon={GrDocumentTime}
        />
      );
    }

    if (segundaVia) {
      if (segundaVia?.base64_segunda_via) {
        boxes.push(
          <BoxLink
            onPress={() => downloadSecondVia(segundaVia?.base64_segunda_via)}
            color={colors.primaryColor}
            name="Segunda Via"
            to="meus-dados"
            icon={GrDocumentTime}
          />
        );
      }
      if (segundaVia?.link_segunda_via) {
        boxes.push(
          <BoxLink
            onPress={() => handleOpenLink(segundaVia?.link_segunda_via)}
            color={colors.primaryColor}
            name="Segunda Via"
            to="meus-dados"
            icon={GrDocumentTime}
          />
        );
      }
      if (segundaVia?.observacao) {
        boxes.push(
          <BoxLink
            onPress={() => toast({ title: segundaVia?.observacao, status: 'info', duration: 9000, isClosable: true })}
            color={colors.primaryColor}
            name="Segunda Via"
            to="meus-dados"
            icon={GrDocumentTime}
          />
        );
      }
    }

    if (lastContrato) {
      boxes.push(
        <BoxLink
          onPress={() => setIsModalOpen(true)}
          color={colors.primaryColor}
          name="Contratos"
          to="meus-dados"
          icon={FaFileContract}
        />
      );

      boxes.push(
        <BoxLink
          onPress={() => {
            if (lastContrato?.codigo_contrato) {
              handleOpenWhatsAppPlan();
            }
          }}
          color={colors.primaryColor}
          name="Upgrade de Planos"
          to="meus-dados"
          icon={MdUpgrade}
        />
      );
      boxes.push(
        <BoxLink
          onPress={() => {
            handleOpenWhatsAppPlan();
          }}
          color={colors.primaryColor}
          name="Entrar em contato"
          icon={FaWhatsapp}
          to="meus-dados"
        />
      );
      boxes.push(
        <BoxLink
          onPress={() => {
            handleDesbloqueio();
          }}
          color={colors.primaryColor}
          name="Desbloqueio de Confiança"
          icon={FaShieldAlt}
          to="meus-dados"
        />
      );
    }

    return boxes;
  }, [lastFatura, colors.primaryColor, segundaVia]);

  const showBoxesFatura = React.useMemo(() => {
    const boxes: any = [];

    faturas.forEach((fatura: any) => {
      boxes.push(
        <BoxFatura
          onPress={() => handleChangeFatura(fatura)}
          color={colors.primaryColor}
          paga={fatura.fatura_paga}
          active={lastFatura?.codigo_fatura === fatura.codigo_fatura}
          title={
            isValidDate(fatura.vencimento)
              ? format(new Date(fatura.vencimento.split('/').reverse().join('-')), 'MMMM yyyy', { locale: ptBR })
              : 'Data inválida'
          }
          subtitle={new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          }).format(Number(fatura.valor))}
        />
      );
    });

    return boxes;
  }, [faturas, colors.primaryColor, lastFatura]);

  React.useEffect(() => {
    if (!customerCentralModule) {
      nav(-1);
    }
  }, [customerCentralModule, nav]);

  return (
    <MainTemplate>
      <VStack align={'self-start'} marginBottom={100} spacing={5} width={{ base: '90%' }} paddingTop={'20px'}>
        <Label>Central do Cliente</Label>

        <Grid width={'100%'} templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }} gap={6}>
          <VStack width={'100%'} spacing={6} overflow={'hidden'}>
            {isLoading ? (
              <Box
                borderRadius="lg"
                backgroundColor="white"
                boxShadow="2px 2px 6px 0px #0000002E"
                padding="20px"
                width="100%"
              >
                <VStack spacing={0} align="center">
                  <VStack spacing={3} width="100%">
                    <Skeleton height="24px" width="70%" borderRadius="md" />
                    <Skeleton height="20px" width="50%" borderRadius="md" />
                    <Skeleton height="20px" width="60%" borderRadius="md" />
                    <Skeleton height="20px" width="40%" borderRadius="md" />
                    <Skeleton height="16px" width="30%" borderRadius="md" />
                  </VStack>
                </VStack>
              </Box>
            ) : (
              <>
                {lastContrato ? (
                  <Box
                    borderRadius="lg"
                    backgroundColor="white"
                    boxShadow="2px 2px 6px 0px #0000002E"
                    padding="20px"
                    width="100%"
                  >
                    <VStack spacing={0} align="center">
                      <Label fontSize="x-large" fontWeight="bold" color={colors.primaryColor}>
                        {profile?.data?.fullName}
                      </Label>

                      <Label fontSize="medium" fontWeight="bold" color="gray.800">
                        <span style={{ fontWeight: 400 }}>N.º Contrato:</span> {lastContrato.codigo_contrato},
                        <span style={{ fontWeight: 400 }}> Plano:</span> {lastContrato.nome_contrato}{' '}
                      </Label>
                      <HStack spacing={1} width="100%" justify="center">
                        <Label fontSize="md" color="gray.600">
                          Vencimento:
                        </Label>
                        <Label fontSize="md" fontWeight="semibold" color="gray.800">
                          {lastContrato.vencimento}
                        </Label>
                      </HStack>
                      {/* <Button variant={'ghost'} onClick={() => setIsModalOpen(true)}>
                        Contratos Antigos
                      </Button> */}
                    </VStack>
                  </Box>
                ) : (
                  <></>
                )}
              </>
            )}
            <VStack spacing={2} align={'flex-start'} width="100%" overflow={'hidden'}>
              <Box
                whiteSpace="nowrap"
                overflowX="auto"
                width={'100%'}
                css={
                  isMobile &&
                  css({
                    scrollbarWidth: 'auto',
                    '::-webkit-scrollbar': { display: 'block' },
                    WebkitOverflowScrolling: 'touch',
                    border: 'none',
                  })
                }
                ref={(box) => {
                  if (box) {
                    box.scrollLeft = box.scrollWidth; // Scroll to the end
                  }
                }}
              >
                {IsLoadingFaturas ? (
                  <>
                    <HStack spacing={4} minWidth="fit-content" display="inline-flex">
                      {Array.from({ length: 3 }).map((_, index) => (
                        <Skeleton key={index} height="50px" width="100px" borderRadius="lg" />
                      ))}
                    </HStack>
                  </>
                ) : (
                  <HStack spacing={4} minWidth="fit-content" display="inline-flex">
                    {showBoxesFatura}
                  </HStack>
                )}
              </Box>

              {IsLoadingFaturas ? (
                <VStack spacing={5} align={'flex-start'} width="100%">
                  <Skeleton height="20px" width="70%" borderRadius="md" />
                  <Skeleton height="30px" width="50%" borderRadius="md" />
                  <Skeleton height="20px" width="60%" borderRadius="md" />
                </VStack>
              ) : (
                lastFatura && (
                  <VStack spacing={5} align={'flex-start'} width="100%">
                    <Label textTransform={'capitalize'} fontSize="medium">
                      {lastFatura.descricao}
                    </Label>
                    <Label color={colors.primaryColor} fontSize="xx-large" fontWeight="bold">
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(Number(lastFatura?.valor))}
                    </Label>
                    <Label fontSize="large" color="gray.600">
                      Vence dia:{' '}
                      {lastFatura?.vencimento && isValidDate(lastFatura.vencimento)
                        ? format(new Date(lastFatura.vencimento.split('/').reverse().join('-')), "dd 'de' MMMM", {
                            locale: ptBR,
                          })
                        : 'Data inválida'}
                    </Label>
                  </VStack>
                )
              )}
            </VStack>
          </VStack>
          <VStack width="100%" spacing={5} align={'flex-start'} overflow="hidden">
            {/* {isMobile && (
              <Box
                whiteSpace="nowrap"
                maxWidth="100%"
                overflowX="auto"
                paddingBottom={'20px'}
                display={'flex'}
                css={css({
                  scrollbarWidth: 'none',
                  '::-webkit-scrollbar': { display: 'none' },
                  WebkitOverflowScrolling: 'touch',
                  border: 'none',
                })}
              >
                {isLoading || isLoadingSegundaVia ? (
                  <HStack spacing={4} minWidth="fit-content" display="inline-flex">
                    {Array.from({ length: 3 }).map((_, index) => (
                      <Skeleton key={index} height="100px" width="100px" borderRadius="lg" />
                    ))}
                  </HStack>
                ) : (
                  <HStack spacing={4} minWidth="max-content" display="flex">
                    {showBoxes}
                  </HStack>
                )}
              </Box>
            )}
 */}
            <Grid templateColumns={{ base: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' }} gap={4} width="100%">
              {isLoading || isLoadingSegundaVia ? (
                Array.from({ length: 6 }).map((_, index) => (
                  <Skeleton key={index} height="100px" width="100%" borderRadius="lg" />
                ))
              ) : (
                <>{showBoxes}</>
              )}
            </Grid>
          </VStack>
        </Grid>
        <Modal isOpen={isModalOpen} onClose={closeModal}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Lista de Contratos</ModalHeader>
            <ModalCloseButton />
            <ModalBody maxHeight={500} overflowY="auto">
              <List spacing={3}>
                {contratos?.map((contrato: IContrat, index: number) => (
                  <ListItem key={index} padding="10px" border="1px solid" borderColor="gray.200" borderRadius="md">
                    <VStack align="flex-start" spacing={1}>
                      <Heading size="sm" color="gray.700">
                        Contrato: {contrato.codigo_contrato} - {contrato.nome_contrato}
                      </Heading>
                      <Label fontSize="sm" color="gray.600">
                        Adesão: {contrato.adesao}
                      </Label>
                      <Label fontSize="sm" color="gray.600">
                        Vencimento: {contrato.vencimento}
                      </Label>
                    </VStack>
                  </ListItem>
                ))}
              </List>
            </ModalBody>
          </ModalContent>
        </Modal>
        {showBoxesFatura.length === 0 && !IsLoadingFaturas && (
          <VStack width={'100%'} spacing={5} paddingTop={'50px'}>
            <FaFrown size="50px" color={colors.primaryColor} />
            <Label textAlign={'center'}>
              {isError
                ? 'Não foi possível consultar faturas. Entre em contato conosco'
                : 'Nenhuma fatura encontrada. Entre em contato conosco'}
            </Label>
            <Button
              onClick={() => handleOpenWhatsApp()}
              backgroundColor={colors.primaryColor}
              color="white"
              variant="solid"
            >
              Chamar no WhatsApp
            </Button>
          </VStack>
        )}
      </VStack>
    </MainTemplate>
  );
}
